import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "title-text" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = {
  key: 0,
  class: "tag-padding"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "title-text" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "title-text" }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "title-text" }
const _hoisted_13 = {
  key: 1,
  class: "progressbar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_EditDate = _resolveComponent("EditDate")!
  const _component_EditTags = _resolveComponent("EditTags")!
  const _component_EditExif = _resolveComponent("EditExif")!
  const _component_EditLocation = _resolveComponent("EditLocation")!
  const _component_EditOrientation = _resolveComponent("EditOrientation")!
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Edit metadata')), 1)
        ]),
        buttons: _withCtx(() => [
          (_ctx.photos)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 0,
                onClick: _ctx.save,
                class: "button",
                variant: "error",
                disabled: _ctx.processing
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Save')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_ctx.photos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.sections.includes(1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('memories', 'Date / Time')), 1),
                      _createVNode(_component_EditDate, {
                        ref: "editDate",
                        photos: _ctx.photos,
                        disabled: _ctx.processing,
                        onSave: _ctx.save
                      }, null, 8, ["photos", "disabled", "onSave"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.config.systemtags_enabled && _ctx.sections.includes(2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('memories', 'Collaborative Tags')), 1),
                      _createVNode(_component_EditTags, {
                        ref: "editTags",
                        photos: _ctx.photos,
                        disabled: _ctx.processing
                      }, null, 8, ["photos", "disabled"]),
                      (_ctx.sections.length === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.sections.includes(3))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('memories', 'EXIF Fields')), 1),
                      _createVNode(_component_EditExif, {
                        ref: "editExif",
                        photos: _ctx.photos,
                        disabled: _ctx.processing,
                        onSave: _ctx.save
                      }, null, 8, ["photos", "disabled", "onSave"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.sections.includes(4))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('memories', 'Geolocation')), 1),
                      _createVNode(_component_EditLocation, {
                        ref: "editLocation",
                        photos: _ctx.photos,
                        disabled: _ctx.processing
                      }, null, 8, ["photos", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.sections.includes(5))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('memories', 'Orientation (EXIF)')), 1),
                      _createVNode(_component_EditOrientation, {
                        ref: "editOrientation",
                        photos: _ctx.photos,
                        disabled: _ctx.processing
                      }, null, 8, ["photos", "disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.processing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_NcProgressBar, {
                  value: _ctx.progress,
                  error: true
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}